import { siteModel } from 'models/SiteModel';

export class loadCoverAsync {
    constructor() {
      this.firstLoad = false;
    }
    dataAdapter(data) {
        const result = {
            calendar: data.calendar,
            range: data.calendarRange,
            currentDay: data.currentCalendarDay,
            currentDayModel: {},
            currentMatchbarDay: data.currentMatchbarDay,
        };
        return result;
    }
    load(range = {}) {
        const executeLoadingData = (resolve, reject) => {
            $.get(`${siteModel.get('paths').matchCalendarRepository}`)
                .done((response) => {
                    const { status, data, redirectURL } = response;

                    if (status === 'ok') {
                        /*
                         * Dispatch event with matches list for MatchBar repository
                         */
                        const evt = new CustomEvent('MatchCalendarLoadExecuted', { detail: data });
                        window.dispatchEvent(evt);

                        const result = this.init = this.dataAdapter(data);
                        resolve(result);
                    } else if (status === 'error') {
                        reject(data.error);
                    } else if (status === 'redirect') {
                        window.location.href = redirectURL;
                    }
                })
                .fail((error) => {
                    reject(error);
                });
        };
        return new Promise(executeLoadingData);
    }
    getFirstDay() {
      return this.init.currentDayModel;
    }
    loadDay(day) {
        const executeLoadingData = (resolve, reject) => {
            $.get(`${siteModel.get('paths').matchCalendarDayRepository.replace('2000-08-20', day)}`)
                .done((response) => {
                    const { status, data, redirectURL } = response;

                    if (status === 'ok') {
                        /*
                         * Dispatch event with current match for MatchBar repository
                         * To avoid double requests we send day to compare in match bar
                         */
                        const evt = new CustomEvent('MatchCalendarDayLoadExecuted', { detail: { date: day, data: data.matchDay } });
                        window.dispatchEvent(evt);

                        resolve(data.matchDay);
                    } else if (status === 'error') {
                        reject(data.error);
                    } else if (status === 'redirect') {
                        window.location.href = redirectURL;
                    }
                })
                .fail((error) => {
                    reject(error);
                });
        };
        return new Promise(executeLoadingData);
    }
    getInterval() {
      return this.init.interval;
    }
    getCurrentDay() {
      return this.init.currentDay;
    }
    getRange() {
      return this.init.range;
    }
    isFirstMatchLive() {
      const matches = this.init.currentDayModel.matches;

      if (matches.length) {
        return matches[0].isLive;
      }

      return false;
    }
};

export const repository = new loadCoverAsync();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/repositories/matchCalendarRepository.js